import { VehicleType } from '@repo/shared'
import { Button, Card, CardContent, cn } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import PageHeader from '@/components/layout/page-header'
import AddBus from '@/features/vehicles/components/bus/add-bus'
import AddTrailer from '@/features/vehicles/components/trailer/add-trailer'
import AddTruck from '@/features/vehicles/components/truck/add-truck'
import { useDocumentTitle } from '@/hooks/use-document-title'
import { localizedPageTitle } from '@/lib/page-title'

export const Route = createFileRoute('/dashboard/vehicles/create')({
  head: () => ({ meta: [{ title: localizedPageTitle('addVehicle') }] }),
  component: RouteComponent,
})

function RouteComponent() {
  useDocumentTitle('addVehicle')
  const { t } = useTranslation('vehicles')

  const [vehicleType, setVehicleType] = useState<VehicleType | null>(
    VehicleType.Truck,
  )

  const handleVehicleTypeSelect = (type: VehicleType) => {
    setVehicleType(type)
  }

  return (
    <div
      className={cn(
        'mx-auto grid max-w-7xl grid-cols-1 grid-rows-[auto_1fr] gap-4 2xl:p-8',
        (vehicleType === VehicleType.Truck ||
          vehicleType === VehicleType.Trailer) &&
          'lg:grid-cols-[65fr_35fr]',
      )}
    >
      {/* Header Card */}
      <PageHeader title={t('addVehicle')} subtitle={t('addVehicleSubtitle')} />

      {/* Vehicle Type Selector */}
      <Card className="border-border bg-background row-start-2 row-end-3 gap-4 p-4">
        <p className="text-muted-foreground text-sm">
          {t('selectVehicleType')}
        </p>
        <div className="flex gap-4">
          <Button
            variant="outline"
            size="lg"
            onClick={() => handleVehicleTypeSelect(VehicleType.Truck)}
            className={cn(
              vehicleType === VehicleType.Truck &&
                'bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground',
            )}
          >
            {t('truck')}
          </Button>
          {/* <Button
            variant="outline"
            size="lg"
            onClick={() => handleVehicleTypeSelect(VehicleType.Bus)}
            className={cn(
              '',
              vehicleType === VehicleType.Bus &&
                'bg-primary text-primary-foreground',
            )}
          >
            {t('bus')}
          </Button> */}
          <Button
            variant="outline"
            size="lg"
            onClick={() => handleVehicleTypeSelect(VehicleType.Trailer)}
            className={cn(
              vehicleType === VehicleType.Trailer &&
                'bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground',
            )}
          >
            {t('trailer')}
          </Button>
        </div>
      </Card>

      {vehicleType === VehicleType.Truck && <AddTruck />}
      {vehicleType === VehicleType.Bus && <AddBus />}
      {vehicleType === VehicleType.Trailer && <AddTrailer />}
    </div>
  )
}
